export default __webpack_public_path__ + "assets/add.ee50bd6a.svg";